import React, { FC } from 'react';
import { ListItem, MenuList } from './IndividualReportSummaryList.styles';
import { orderGroupDistribution } from '../../helpers/helpers';
import {
  IIndividualStatesTopic,
  IIndividualStatesTopicsData,
  IWorkEnvironmentCategory,
  IWorkEnvironmentCategoryData,
} from '../../services/individualReport';
import IndividualReportSummaryCard from '../IndividualReportSummaryCard/IndividualReportSummaryCard';

interface IIndividualReportSummaryCategoryList {
  data: IWorkEnvironmentCategoryData[];
  mode: 'results' | 'group';
  type: 'categories';
  onClick?: (category: IWorkEnvironmentCategory) => void;
}

interface IIndividualReportSummaryTopicList {
  data: IIndividualStatesTopicsData[];
  mode: 'results' | 'group';
  type: 'topics';
  onClick?: (topic: IIndividualStatesTopic) => void;
}

type TIndividualReportSummaryList =
  | IIndividualReportSummaryCategoryList
  | IIndividualReportSummaryTopicList;

const IndividualReportSummaryList: FC<TIndividualReportSummaryList> = ({
  data,
  mode,
  type,
  onClick,
}) => (
  <MenuList aria-label={mode} id="MenuList">
    {type === 'categories'
      ? data.map(({ category, group_distribution, score, score_rating }) => {
          const { code, title } = category;

          return (
            <ListItem id="ListItem" key={code}>
              <IndividualReportSummaryCard
                distribution={orderGroupDistribution(group_distribution)}
                onClick={() => onClick && onClick(category)}
                {...{ mode, score, score_rating, title, code }}
              />
            </ListItem>
          );
        })
      : null}
    {type === 'topics'
      ? data.map(({ group_distribution, score, score_rating, topic }) => {
          const { code, title } = topic;

          return (
            <ListItem id="ListItem" key={code}>
              <IndividualReportSummaryCard
                distribution={orderGroupDistribution(group_distribution)}
                onClick={() => onClick && onClick(topic)}
                {...{ mode, score, score_rating, title, code }}
              />
            </ListItem>
          );
        })
      : null}
  </MenuList>
);

export default IndividualReportSummaryList;
